import React, { useState } from 'react';

const TagInput = ({ field, formData, setFormData, isSubmitting }) => {
  const tagColors = ['bg-blue-100 text-blue-800', 'bg-green-100 text-green-800', 'bg-purple-100 text-purple-800', 'bg-yellow-100 text-yellow-800', 'bg-red-100 text-red-800'];
  const [currentTagInput, setCurrentTagInput] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState(field.suggestions);

  const handleTagInputChange = (e) => {
    const value = e.target.value;
    setCurrentTagInput(value);
    setFilteredSuggestions(field.suggestions.filter(s =>
      s.toLowerCase().includes(value.toLowerCase()) &&
      !formData[field.name].includes(s)
    ));
  };

  const handleAddTag = (tagToAdd) => {
    const newTag = tagToAdd || currentTagInput.trim();
    if (newTag && !formData[field.name].includes(newTag)) {
      setFormData(prev => ({
        ...prev,
        [field.name]: [...prev[field.name], newTag]
      }));
      setCurrentTagInput('');
      setFilteredSuggestions(field.suggestions.filter(s => !formData[field.name].includes(s) && s.toLowerCase().includes(currentTagInput.toLowerCase())));
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      [field.name]: prev[field.name].filter(tag => tag !== tagToRemove)
    }));
    setFilteredSuggestions(field.suggestions.filter(s => !formData[field.name].includes(s) && s.toLowerCase().includes(currentTagInput.toLowerCase())));
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <input
          type="text"
          value={currentTagInput}
          onChange={handleTagInputChange}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddTag();
            }
          }}
          className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] placeholder-gray-500"
          placeholder={field.placeholder || "Add a tag and press Enter or click Add"}
          disabled={isSubmitting}
        />
        <button
          type="button"
          onClick={() => handleAddTag()}
          className="px-4 py-2 bg-[#bb1ccc] text-white rounded-md hover:bg-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isSubmitting || !currentTagInput.trim()}
        >
          Add
        </button>
      </div>

      <div className="flex flex-wrap gap-2 mb-2">
        {formData[field.name].map((tag, index) => (
          <span
            key={tag}
            className={`${tagColors[index % tagColors.length]} px-3 py-1 rounded-full text-sm flex items-center gap-1`}
          >
            {tag}
            <button
              type="button"
              onClick={() => handleRemoveTag(tag)}
              className="ml-1 text-inherit hover:text-[#000080] focus:outline-none"
              disabled={isSubmitting}
            >
              &times;
            </button>
          </span>
        ))}
      </div>

      {filteredSuggestions.length > 0 && (
        <div className="border border-gray-300 rounded-md p-2 max-h-40 overflow-y-auto bg-white shadow-sm">
          <p className="text-sm text-gray-500 mb-2">Suggestions:</p>
          <div className="flex flex-wrap gap-2">
            {filteredSuggestions.map((suggestion) => (
              <button
                key={suggestion}
                type="button"
                onClick={() => handleAddTag(suggestion)}
                className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm hover:bg-gray-200"
                disabled={isSubmitting}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagInput; 